import DraggableScroll from './__modules/__page/draggableScroll';
import Tabs from "./__modules/__page/tabs";
import VideoWithFilters from "./__modules/__blocks/videoWithFilters";
import {mobileMenu} from "./__modules/__header/mobileMenu";
import Search from "./__modules/__header/search";
import {tableWrapper} from "./__modules/__page/table";
import {VideoPopup} from "./__modules/__page/videoPopup";
import {searchableDropdown} from "./__modules/__page/searchableDropdown";
import WineDataBase from "./__modules/__blocks/wineDateBase";
import TripAndTripAndWines from "./__modules/__blocks/tripAndWines";
import MainSlider from "./__modules/__blocks/mainSlider";
import EventsSlider from "./__modules/__blocks/eventsSlider";
import WineDataBasePopup from "./__modules/__page/wineDataBasePopup";
import WineDataBaseSearchComponent from "./__modules/__blocks/wineDataBaseSearchComponent";
import {winesByPrice, winesByType} from "./__modules/__blocks/winesByPrice";
import CalendarMap from "./__modules/__page/calendarMap";
import TripsByCategory from "./__modules/__blocks/tripsByCategory";
import {scrollDown} from "./__modules/__header/scrollDown";
import {menuDropdown} from "./__modules/__header/menuDropdown";

const $ = jQuery.noConflict();
$('html').removeClass('no-js');


$('.tiles-slider-wrapper').each((i, e) => {
    const slider = new DraggableScroll($(e));
    slider.init();
});

const tabsBlocks = new Tabs($('.block-tabs'));

(new VideoWithFilters).init();
mobileMenu();
tableWrapper();
VideoPopup();
searchableDropdown();
(new WineDataBase).init();
(new MainSlider).init();
(new EventsSlider).init();
(new WineDataBasePopup).init();
(new WineDataBaseSearchComponent).init();
winesByPrice.init();
winesByType.init();
(new TripAndTripAndWines()).init();
(new CalendarMap).init();
(new TripsByCategory).init();
(new Search).initTriggers();
tabsBlocks.initTriggers();
menuDropdown();
scrollDown();

window.onresize = () => {
};

jQuery(window).scroll(() => {
});

jQuery(document).mouseup((e) => {
});
